import Swiper from "swiper"
import { setCookie } from '../../resources/js/utils/gate'
import { Autoplay } from 'swiper/modules';
import { lightbox } from '../../resources/js/utils/lightbox'

import 'swiper/css';

import { gsap, ScrollTrigger } from "gsap/all";
import { qs, qsa } from "../../resources/js/utils/dom";
gsap.registerPlugin(ScrollTrigger);

if (qs(".timeline")) {
  const container = qs(".timeline"),
  animationLenght = 300;
  //isMobile = window.matchMedia('(max-width: 1023px)').matches;

  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top top",
      pin: true,
      end: "bottom+=" + animationLenght * qsa('.timeline-item').length,
      scrub: 0.05,
      toggleActions: "play pause play reverse",
      onEnter: () => {
        qs("header").classList.add('hidden')
      },

      onEnterBack: () => {
        qs("header").classList.add('hidden')
      },

      onLeave: () => {
        qs("header").classList.remove('hidden')
      },

      onLeaveBack: () => {
        qs("header").classList.remove('hidden')
      },
    },
  });

  const maxValue = window.innerHeight - Number((qs('.timeline').style.paddingTop).replace(/[^0-9]/g, '')) - 24 - qs('.timeline-header').offsetHeight - qs('.timeline-nav').offsetHeight;

  qsa('.timeline-item').forEach((item, index) => {
    item.style.height = maxValue + "px";
    if (index != 0) {
      let activeStep = qs(`.timeline-steps--item[data-active=${item.dataset.active}]`);
      if (activeStep) {
        tl.to('.timeline-nav--line.active', {
          width: qs('.timeline-steps--counter', activeStep).offsetLeft + Number((qs('.timeline-steps--counter', activeStep).style.marginLeft).replace(/[^0-9]/g, '')) + "px",
        });
      } else {
        tl.to('.timeline-nav--line.active', {
          width: "100%",
        });
      }

      tl.to(item, {
        onStart: () => {
          if (activeStep) {
           // qs('.timeline-nav--line.active').style.width = qs('.timeline-steps--counter', activeStep).offsetLeft + "px";
            activeStep.classList.add('active')
          }
          item.classList.add('active')
        },
        onReverseComplete: () => {
          if (activeStep) {
            activeStep.classList.remove('active')
            //qs('.timeline-nav--line.active').style.width = qs(`.timeline-steps--item[data-active=${array[index - 1].dataset.active}] .timeline-steps--counter`).offsetLeft + "px";
          }
          item.classList.remove('active')
        },
      });
    }
  });

  qs('.timeline-items').style.height = maxValue + "px";
  qs('.timeline-nav--line.active').style.width = qs('.timeline-steps--item:first-child .timeline-steps--counter').offsetLeft + "px";

}

const relatedSliderInit = () => {
  new Swiper('.related', {
  modules: [Autoplay],
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoplay: {
      delay: 5000,
    },
  });
}

window.addEventListener('load', () => {
  relatedSliderInit()
  lightbox('.lightbox', true)
});

window.addEventListener('resize', () => {
  relatedSliderInit()
});

window.addEventListener('message', event => {
   if(event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit' && qs('.with-form')) {
      const submittedformId = qs('.with-form').id
      setCookie(`${submittedformId}`, 'filled', 7)

      qsa('.gated').forEach((element) => {
        element.classList.remove('gated')
      })

      qsa('.btn-access').forEach((element) => {
        element.remove()
      })
   }
});
